import { END_POINT } from "@constants/api.constants";
import { checkForExpiredToken } from "@screens/system/settings/setting-list/setting.list.service";
import { store } from "@src/store";

const { SITE_SETTINGS_EDIT, SITE_SETTINGS_LIST } = END_POINT;

export const editSiteSettings = async (id, payload) => {
  return await fetch(`${SITE_SETTINGS_EDIT}${id}`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status) return { status: true, data: data.data };
      else {
        checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getSiteSettingsById = async (id) => {
  return await fetch(`${SITE_SETTINGS_LIST}?site_settings_id=${id}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status && data.data.list && data.data.list.length > 0) {
        return { status: true, data: data.data.list[0] };
      } else {
        checkForExpiredToken(data.message);
        return { status: false, message: data.message || "Customer not found" };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};